import React, { lazy } from 'react'

const BankCodeListing = lazy(() =>
  import('./BankCodeListing').then(module => ({
    default: module.BankCodeListing,
  }))
)

 
export const BankCodeRoutes = [
  {
    props: {
      exact: true,
      path: `/common-setting/bank-code`,
    },
    component: <BankCodeListing />,
  },
]

export default BankCodeRoutes
